import CardProfileFollow from "./CardProfileFollow";
export default CardProfileFollow;